"use client";

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from "next/navigation";
import { Suspense } from "react";
import { SellContent } from "./home";
import { PostPropertyFlow } from "./post-property-flow";
function SellFlowContentWrapper() {
  const $ = _c(4);
  const searchParams = useSearchParams();
  let t0;
  if ($[0] !== searchParams) {
    t0 = Array.from(searchParams?.keys() || []);
    $[0] = searchParams;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const showStepper = t0.length > 0;
  let t1;
  if ($[2] !== showStepper) {
    t1 = showStepper ? <PostPropertyFlow /> : <SellContent />;
    $[2] = showStepper;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
}
export function SellFlowSuspenseWrapper() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Suspense fallback={<div className="min-h-screen bg-background flex items-center justify-center"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" /></div>}><SellFlowContentWrapper /></Suspense>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
export { SellFlowSuspenseWrapper as SellContentWrapper };